var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('nav-bar'),_c('hero'),_c('separator-white'),_c('quienes-somos'),_c('separator-pink'),_c('candidatos'),_c('separator-red'),_c('empresas'),_c('separator-yellow'),_c('linkedin'),_c('separator-white'),_c('legal-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }